import { InjectionToken } from '@angular/core';

export const DISK_PRELOAD_USER_ID_STORAGE_KEY = new InjectionToken<string>('DISK_PRELOAD_USER_ID_STORAGE_KEY');
